import React from "react";
import { HiOutlineUserCircle } from "react-icons/hi2";
import "./UserMiniCard.css";

export default function UserMiniCard({ name, email }) {
  return (
    <div className="bb-user-mini-card">
      <div className="bb-user-mini-card__icon">
        <HiOutlineUserCircle />
      </div>

      <div className="bb-user-mini-card__content">
        <h6 className="bb-user-mini-card__name">{name}</h6>
        <p className="bb-user-mini-card__email">{email}</p>
      </div>
    </div>
  );
}
